
import React  from 'react';
import { List, Segment, Divider, Table, Grid, Image, Header, Icon, Accordion,Progress, Popup, Container, Label, Button} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import Container1 from '../dragDrop/ContainerNivel1'
import Container2 from '../dragDrop/ContainerNivel2'
import Container3 from '../dragDrop/ContainerNivel3'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import update from 'immutability-helper'

const Modulos=({ id, margenes, onVisible, modulos, onAcordionModulo, onAcordionModuloOff, olor, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, showModalComents, handleClick, fechaActual, fechaComentario, titulo, allowAccess,onShowModal, onSelect, moduloActivo, contenidoView, modulo, onAcordionContenido,contenidoActivo, contenido, agrupador, onAcordionContenidoOff, onSaveOrden, onSaveOrdenModulo, onSaveOrdenContenido, onEliminar, onEliminarModulo})=>{

    return (
        <Segment>
            <Segment >    
             <Grid>
                <Grid.Row columns="2" >
                    <Grid.Column width="13">

                        <Icon size="large" color="grey"  name="plus" color="teal" link onClick={()=>onShowModal("Módulo", 1)}/>
                        Nuevo módulo


                    </Grid.Column>
                      <Grid.Column width="3" textAlign='right' >    
                                <Button  color="black"
                                    onClick={onSaveOrden}>Guardar orden
                                 </Button>

                        </Grid.Column>

                    </Grid.Row>
                </Grid>
            </Segment>
                
                
            {!moduloActivo?
                <DndProvider backend={HTML5Backend}>
                    {modulos.length>0?
                        <Container1
                            modulos={modulos}
                            onAcordionModulo={onAcordionModulo}
                            onShowModal={onShowModal}
                            onEliminarModulo={onEliminarModulo}
                        />
                        :
                        ""
                    }
                </DndProvider>

            :
            
            <div>
               <Segment ribbon style={{ background: "#B8D8D5"}} >
                        <Grid>
                            <Grid.Row columns="2" >
                                <Grid.Column width="13"  only='computer tablet '>
                                    <Label as='a' onClick={()=>onAcordionModuloOff(modulo.idModulo)} color='teal' ribbon size="big">
                                        {modulo.tituloModulo}
                                    </Label>    
                                        
                                    <br/><br/>

                                    <Header as='h5' floated='left'>
                                        {modulo.descModulo}
                                        <Header.Subheader>
                                            {/*modulo.contenido.length*/} actividades
                                        </Header.Subheader>
                                    </Header>

                                </Grid.Column>

                                <Grid.Column width="13"  only='mobile'>
                                    <Label as='a' onClick={()=>onAcordionModuloOff(modulo.idModulo)} color='teal' ribbon size="medium">
                                      {modulo.titulo}
                                    </Label>    

                                    <br/><br/>

                                    <Header  floated='left'>
                                        {modulo.descripcion}
                                        <Header.Subheader>
                                            {/*modulo.contenido.length*/} actividades
                                        </Header.Subheader>
                                    </Header>

                                </Grid.Column>               

                                <Grid.Column width="3" textAlign='right' verticalAlign="middle">
                                    <Icon size="large" color={modulo.activo?"grey":"teal"}  name={modulo.activo?"minus":"plus"} link onClick={()=>onAcordionModuloOff(modulo.idModulo)}/>
                                </Grid.Column>

                            </Grid.Row>
                        </Grid>
                    </Segment>
                            
                    {contenidoActivo===false?                
                            <Segment >    
                             <Grid>
                                <Grid.Row columns="2">
                                    <Grid.Column width="13" >    
                        
                                        <Icon size="large" color="grey"  name="plus" color="teal" link onClick={()=>onShowModal("Contenido", 2)}/>
                                        Nuevos Sección/Contendio

                    
                                    </Grid.Column>
                                    <Grid.Column width="3" textAlign='right' >
                     

                                        <Button  color="black"
                                        onClick={onSaveOrdenContenido}>Guardar orden
                                        </Button>

                                    </Grid.Column>

                                    </Grid.Row>
                                </Grid>
                            </Segment>
                                    
                    :""}
                                    
                     {contenidoView.length>0 && contenidoActivo===false?

                      <Segment basic>
                         
                            <DndProvider backend={HTML5Backend}>

                                <Container2
                                    modulos={contenidoView}
                                    onAcordionContenido={onAcordionContenido}
                                    onShowModal={onShowModal}
                                    onEliminar={onEliminar}
                                />

                            </DndProvider>
                        </Segment>        
                    :
                     
                        ""
                                    
                     }
                                    
            
            </div>
            
            
            }
     
        </Segment>
	);
};



export default Modulos;